

























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'AccountCopyRecords',
})

export default class AccountCopyRecords extends Vue {
    @Prop() public isCopyRecordsDialogVisible!: boolean;
    @Prop({
        required: true,
    }) protected options!: string[];

    protected checkList: string[] = [];

    protected closeDialog() {
        this.$emit('closeDialog', 'copy');
    }

    protected onCopyItem() {
        this.$emit('copyRecords', this.checkList);
    }
}
